// Here we will have common view parts
import icons from '../../img/icons.svg';

export default class View {
    _data;
    
    /**
     * Render the received object to the DOM
     * @param {Object | Object[]} data The data to be rendered (e.g. recipe) 
     * @param {boolean} [render=true] If false, create markup string instead of rendering to the DOM
     * @returns {undefined | string} A markup string is returned if render = false
     * @this {Object} View instance
     * @todo Finish implementation
     */
    
    render(data, render = true) {
        // We want to display an error message when there is not information to render in the
        // results view. If we receive an empty array it also counts as no data
        if(!data || (Array.isArray(data) && data.length === 0)) return this.renderError(); 


        this._data = data;
        // Stores the given HTML from _generateMarkup()
        const markup = this._generateMarkup();

        // DOUBT
        if(!render) return markup;

        this._clear();
        this._parentElement.insertAdjacentHTML('afterbegin', markup);
    }

    // DOM updating algorithm
    update(data) {
      // We're removing this line because if we refresh the page as we didn't search for anything,
      // data becomes an empty array so it renders the error. Removed because we don't want that
      // if(!data || (Array.isArray(data) && data.length === 0)) return this.renderError(); 
      this._data = data;
      const newMarkup = this._generateMarkup();
      /* 
         This method will convert 'newMarkup' string to a DOM object.
         Is the equivalent of creating a virtual DOM that will be living in the memory.
         Now we will be able to use this virtual DOM as if it was the DOM of our page
      */
      const newDOM = document.createRange().createContextualFragment(newMarkup);
      // Selecting all element from DOM and converting from NodeList to Array
      const newElements = Array.from(newDOM.querySelectorAll('*'));
      // console.log('Virtual DOM new elements: ', newElements);
      const currElements =  Array.from(this._parentElement.querySelectorAll('*'));
      // console.log('DOM current elements: ', currElements);

      // Comparting future virtual DOM with current DOM
      newElements.forEach((newEl, i) => {
        const currEl = currElements[i];
        // With method isEqualNode() we compare if the content of virtual DOM node and current DOM node
        // is the same. We're not using === because we don't want to compare if they are the same element,
        // we want to compare if they have the same content.
        // console.log(currEl, newEl.isEqualNode(currEl));

        /* 
           If virtual DOM element is different from current DOM element and newEl 
           has something on nodeValue (text) (DOUBTS: 296. Developing a DOM Updating Algorithm)
           This way we avoid those elements who haven't changed and we only update that ones that did

           BTW: On second condition we're using '?', conditional operator. With this we make sure that
           if 'firstChild' doesn't exists the expression returns false

           Not understanding: newEl.firstChild?.nodeValue.trim() !== ''
        */

        // Updates changed text
        if(!newEl.isEqualNode(currEl) && newEl.firstChild?.nodeValue.trim() !== '') {
          currEl.textContent = newEl.textContent;
        }

        // Updates changed attributes of changed nodes. For example "data-update-to"
        if(!newEl.isEqualNode(currEl)) {
          // Here we will be logging the attribute property of all changed elements
          // console.log(Array.from(newEl.attributes));
          Array.from(newEl.attributes).forEach(attr => 
            currEl.setAttribute(attr.name, attr.value));
        }

      });

    }

    _clear() {
        this._parentElement.innerHTML = '';
    }

    renderSpinner = function () {
        const markup = `
          <div class="spinner">
            <svg>
              <use href="${icons}#icon-loader"></use>
            </svg>
          </div>
        `;

        this._clear();
        this._parentElement.insertAdjacentHTML('afterbegin', markup);
    };

    renderError(msg = this._errorMessage) {
      const markup = `
        <div class="error">
          <div>
            <svg>
              <use href="${icons}#icon-alert-triangle"></use>
            </svg>
          </div>
          <p>${msg}</p>
        </div>
      `;
      this._clear();
      this._parentElement.insertAdjacentHTML('afterbegin', markup);
    }

    renderMessage(msg = this._successMessage, parentEl = this._parentElement) {
      const markup = `
          <div class="message">
            <div>
              <svg>
                <use href="${icons}#icon-smile"></use>
              </svg>
            </div>
            <p>${msg}</p>
          </div>
      `;
      this._clear();
      this.parentEl.insertAdjacentHTML('afterbegin', markup);
    }
}